<template>
  <div
    class="footer"
  >
    <label class="src">
      <label class="src-selector-span mobile_hide">各國預報路徑</label>
      <div
        v-for="(src_info, index) in src_info_list"
        :key="'div_src_option'+index"
        class="src-option"
      >
        <label
          class="btn-tiny u-margin-right-XS btn_white"
          :for="'src_option-checkbox' + index"
          :key="'src_option-checkbox-label' + index"
        >
          <input
            type="checkbox"
            :disabled="src_info.has_data === false"
            :key="'src_option-checkbox' + index"
            :id="'src_option-checkbox'+ index"
            :checked="is_selected_src_exist(src_info.id)"
            @change="toggle_selected_src(src_info.id, $event.target.checked)"
            class="u-hide"
          >
          <div
            class="btn_footer btn_underline u-text-align-center"
            :class="src_info.has_data ? '' : 'btn_gray btn_disable'"
            :title="src_info.has_data ? '' : '目前並無該國家資料'"
          >
            <span
              class="src_color"
              :style="{backgroundColor: src_info.color}"
            >
            </span>
            {{ src_info.name_zhtw }}
          </div>
        </label>
      </div>
    </label>
    <label class="tc_hint">
      <template v-for="(tc_hint, index) in tc_hints">
      <div
        class="hint_icon"
        :key="'div_tc_hint_icon'+index"
      >
        <i
          :class="tc_hint.icon"
        ></i>
      </div>
      <div
        class="div_tc_hint"
        :key="'div_tc_hint'+index"
      >
        {{ tc_hint.description }}
      </div>
      </template>
    </label>
    <div class="footer_overflow" v-show="first_time_visit_typhoontw">
      <picture>
        <source
        srcset="../../assets/imgs/TT-tiny-img/finger.png, ../../assets/imgs/TT-tiny-img/finger@2x.png 2x, ../../assets/imgs/TT-tiny-img/finger@3x.png 3x"
        media="(min-width: 576px)"
        class="footer_overflow-img"
        >
        <img
        src="../../assets/imgs/TT-tiny-img/finger.png"
        alt="My default image"
        class="footer_overflow-img"
        >
      </picture>
    </div>
  </div>
</template>
<script>
/* eslint-disable camelcase */
import * as types from '@/store/types'
import {mapGetters, mapActions} from 'vuex'
export default {
  components: {},
  data () {
    return {
      tc_hints: [{
        icon: 'icon-TD',
        description: '熱帶性低氣壓'
      }, {
        icon: 'icon-M_TY',
        description: '輕度颱風'
      }, {
        icon: 'icon-S_TY',
        description: '中度、強烈颱風'
      }, {
        icon: 'icon-N_TY',
        description: '颱風(未標明強度)'
      }],
      first_time_visit_typhoontw: true
    }
  },
  methods: {
    ...mapActions({
      set_options: types.SET_OPTIONS
    }),

    is_selected_src_exist (src) {
      return this.selected_src_options.filter((x) => x === src).length > 0
    },

    toggle_selected_src: function (src, toggle) {
      let selected_srcs = this.selected_src_options

      if (toggle && !this.is_selected_src_exist(src)) {
        selected_srcs.push(src)

        this.set_options({'selected_src': selected_srcs})
      } else if (!toggle && this.is_selected_src_exist(src)) {
        let index = selected_srcs.indexOf(src)

        if (index > -1) {
          selected_srcs.splice(index, 1)
          this.set_options({'selected_src': selected_srcs})
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      get_src_info_list: types.GET_SRC_INFO_LIST,
      get_options: types.GET_OPTIONS
    }),

    src_info_list () {
      return this.get_src_info_list.sort(function (a, b) { return a.order - b.order })
    },

    selected_src_options () {
      return this.get_options.selected_src
    }
  },
  mounted () {
    if (typeof(Storage) !== "undefined") {
      if (localStorage.touch_typhoontw) {
          this.first_time_visit_typhoontw = false;
      }
      localStorage.setItem("touch_typhoontw", 1);
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/typhoon_tw/Footer.vue